import { render } from "./SvgLogo.vue?vue&type=template&id=ac2c51d6"
import script from "./SvgLogo.vue?vue&type=script&lang=js"
export * from "./SvgLogo.vue?vue&type=script&lang=js"

import exportComponent from "/Users/geoffsargison/Documents/laravel-valet/ces-calculator/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__